import { ActionErrorDescription } from '../../notification/notification-toastr/types/actionErrorDescription.decorator';
import { LongRunningAction } from '../../server-communication/running-actions/types/longRunningAction.decorator';
import { LongRunningContextCategoryTyp } from '../../../samwebDescription/samweb/waitingContext/waitingContextCategory';
import { AuthenticationStateEnum } from './authentication-state-enum';
import { MicrosoftEntraIdAuthenticationSettings } from '../../authentication-settings/microsoft-entra-id-authentication-settings';

@LongRunningAction(LongRunningContextCategoryTyp.AUTHENTICATION)
export class SignInAction {
   public static readonly type = '[Authentication] SignInAction';

   constructor(public username: string, public password: string) {}
}

@ActionErrorDescription({
   ignoreActionFailure: true,
})
export class AuthenticateWithWindowsAuthentication {
   public static readonly type = '[Authentication] authenticate with windows authentication';

   constructor() {}
}

export class AuthenticateWithTeamsToken {
   public static readonly type = '[Authentication] authenticate with teams token';

   constructor(public teamsToken: string) {}
}

export class SwitchSessionIdAction {
   public static readonly type = '[Authentication] SwitchSessionIdAction';

   constructor(public newSessionId: string) {}
}

export class AuthenticationResult {
   public static readonly type = '[Authentication] Authentication result';

   constructor(public newState: AuthenticationStateEnum) {}
}

export class AuthenticationValidationResetAction {
   public static readonly type = '[Authentication] Validation Reset';
}

@LongRunningAction(LongRunningContextCategoryTyp.AUTHENTICATION)
export class AuthenticateWithMicrosoftEntraIdToken {
   public static readonly type = '[Authentication] Authenticate With Microsoft Entra ID Token';

   constructor(public settings: MicrosoftEntraIdAuthenticationSettings) {}
}

export class SignOutFromMicrosoftEntraId {
   public static readonly type = '[Authentication] Sign-Out From Microsoft Entra ID';

   constructor(public settings: MicrosoftEntraIdAuthenticationSettings) {}
}
